import React from "react";
import { ComputedContextFrame, ContextFrame, ContextPlane, TimeCut } from "../../model/context";
import { NOTE_WIDTH, tickToPosition } from "../../render/renderUtils";
import { useZoomFactor } from "../../stores/ZoomStore";
import './RydContextLayer.css';


export function RydContextFramesLines({
    framesData
}: {
    framesData: {
        ccf: ComputedContextFrame,
        tc: ContextFrame,
        i: number
    }[]
}) {
    const zoomFactor = useZoomFactor();
    const parentCellsVisible = false;

    return (<div className="context-layer--row">
        {framesData
            .map(({ccf, tc, i}) => {
                const computedContextFrame = ccf
                return <div
                    key={i}
                    style={{
                        position: 'relative',
                        width: `calc(${tickToPosition(NOTE_WIDTH, zoomFactor, tc.end - tc.start)}px)`,
                        height: '100%',
                        backgroundColor: '#888',
                        borderLeft: '1px solid #444',
                        boxSizing: 'border-box',
                        fontFamily: 'monospace',
                    }}
                >
                    {parentCellsVisible &&
                        <ul style={{ margin: '2px', padding: '0px', fontSize: '10px', listStyleType: 'none' }}>
                            {tc.cells.map((c, ci) => Object.entries(c.properties)
                                .map(([key, value]) => {
                                    switch (key) {
                                        case 'metronome':
                                        case 'timeSignature':
                                        case 'tonality':
                                            return <li key={key}>{value.toString()}</li>;
                                        default:
                                            return <li key={key}>{`${key}:${JSON.stringify(value)}`}</li>;
                                    }
                                })
                            )}
                        </ul>}

                    <ul style={{ margin: '2px', padding: '0px', fontSize: '10px', listStyleType: 'none' }}>
                        <li>
                            {computedContextFrame.metronome
                                ? computedContextFrame.metronome.toString()
                                : <span className="context--compute-error">Metronome</span>}
                        </li>
                        <li>
                            {computedContextFrame.timeSignature
                                ? computedContextFrame.timeSignature.toString()
                                : <span className="context--compute-error">Time Signature</span>}
                        </li>
                        <li>
                            {computedContextFrame.tonality
                                ? computedContextFrame.tonality.toString()
                                : <span className="context--compute-error">Tonality</span>}
                        </li>
                    </ul>
                </div>
            })}
    </div>)
}